<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Edit
      @if (!loading && organisation) {
        <p class="subtitle">{{organisation.title}}</p>
      }
    </ion-title>
    @if (online && !loading) {
      <ion-buttons slot="end">
        <ion-button (click)="update()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (online && !loading) {
    <ion-grid class="form">
      <ion-row>
        <ion-col>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                <ion-input type="text" inputmode="text" maxlength="100" label="Title" labelPlacement="stacked" fill="outline" [(ngModel)]="params['title']"></ion-input>
              </ion-col>
            </ion-row>
            @if (permissionService.isPermitted('pos-organisations-edit-organisation-allow-on-account-payment-method')) {
              <ion-row>
                <ion-col>
                  <ion-item lines="none" class="ion-no-padding">
                    <ion-toggle class="form-toggle" alignment="start" label-placement="stacked" [(ngModel)]="params['allow_on_account_payment_method']">Allow on account payment</ion-toggle>
                  </ion-item>
                </ion-col>
              </ion-row>
            }
            @if (permissionService.isPermitted('pos-organisations-edit-organisation-pricing-tier') && pricing_tiers && pricing_tiers.length != 0) {
              <ion-row>
                <ion-col>
                  <ion-select okText="OK" interface="alert" label="Pricing tier" labelPlacement="stacked" fill="outline" [(ngModel)]="params['pricing_tier_id']">
                    @for (pricing_tier of pricing_tiers; track pricing_tier) {
                      @if (pricing_tier.sellable == true) {
                        <ion-select-option value="{{pricing_tier.id}}">{{pricing_tier.title}}</ion-select-option>
                      }
                    }
                  </ion-select>
                </ion-col>
              </ion-row>
            }
          </ion-grid>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                <h3>Notes</h3>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-textarea type="text" inputmode="text" maxlength="500" [autoGrow]="true" rows="5" labelPlacement="stacked" fill="outline" [(ngModel)]="params['internal_note']">
                  <div slot="label">Internal note<ion-text class="optional">optional</ion-text></div>
                </ion-textarea>
              </ion-col>
            </ion-row>
          </ion-grid>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                <h3>Mailing address</h3>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                @if (mailing_address_country) {
                  <ion-input class="modal-input" readonly="true" label="Country" labelPlacement="stacked" fill="outline" (click)="presentMailingAddressCountryPickerModal()" value={{mailing_address_country.title}}></ion-input>
                }
                @if (!mailing_address_country) {
                  <ion-input class="modal-input" readonly="true" label="Country" labelPlacement="stacked" fill="outline" (click)="presentMailingAddressCountryPickerModal()"></ion-input>
                }
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="params['mailing_address_premises']">
                  <div slot="label">Unit / Level / Building<ion-text class="optional">optional</ion-text></div>
                </ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-input type="text" inputmode="text" maxlength="100" label="Line 1" labelPlacement="stacked" fill="outline" [(ngModel)]="params['mailing_address_line_1']"></ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="params['mailing_address_line_2']">
                  <div slot="label">Line 2<ion-text class="optional">optional</ion-text></div>
                </ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-input type="text" inputmode="text" maxlength="50" label="Town / City" labelPlacement="stacked" fill="outline" [(ngModel)]="params['mailing_address_locality']"></ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                @if (mailing_address_subdivision_label_changed && mailing_address_requires_subdivision) {
                  <ion-select cancelText="Close" interface="alert" label="{{mailing_address_subdivision_label}}" labelPlacement="stacked" fill="outline" [(ngModel)]="params['mailing_address_subdivision']">
                    @for (subdivision of mailing_address_subdivisions; track subdivision) {
                      <ion-select-option value="{{subdivision.title}}">{{subdivision.title}}</ion-select-option>
                    }
                  </ion-select>
                }
                @if (mailing_address_subdivision_label_changed && !mailing_address_requires_subdivision) {
                  <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="params['mailing_address_subdivision']">
                    <div slot="label">{{mailing_address_subdivision_label}}<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                }
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                @if (mailing_address_requires_postal_code) {
                  <ion-input type="text" inputmode="text" maxlength="10" label="{{mailing_address_postal_code_label}}" labelPlacement="stacked" fill="outline" [(ngModel)]="params['mailing_address_postal_code']"></ion-input>
                }
                @if (!mailing_address_requires_postal_code) {
                  <ion-input type="text" inputmode="text" maxlength="10" labelPlacement="stacked" fill="outline" [(ngModel)]="params['mailing_address_postal_code']">
                    <div slot="label">{{mailing_address_postal_code_label}}<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                }
              </ion-col>
            </ion-row>
          </ion-grid>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                <h3>Billing address</h3>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                @if (billing_address_country) {
                  <ion-input class="modal-input" readonly="true" label="Country" labelPlacement="stacked" fill="outline" (click)="presentBillingAddressCountryPickerModal()" value={{billing_address_country.title}}></ion-input>
                }
                @if (!billing_address_country) {
                  <ion-input class="modal-input" readonly="true" label="Country" labelPlacement="stacked" fill="outline" (click)="presentBillingAddressCountryPickerModal()"></ion-input>
                }
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="params['billing_address_premises']">
                  <div slot="label">Unit / Level / Building<ion-text class="optional">optional</ion-text></div>
                </ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-input type="text" inputmode="text" maxlength="100" label="Line 1" labelPlacement="stacked" fill="outline" [(ngModel)]="params['billing_address_line_1']"></ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="params['billing_address_line_2']">
                  <div slot="label">Line 2<ion-text class="optional">optional</ion-text></div>
                </ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-input type="text" inputmode="text" maxlength="50" label="Town / City" labelPlacement="stacked" fill="outline" [(ngModel)]="params['billing_address_locality']"></ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                @if (billing_address_subdivision_label_changed && billing_address_requires_subdivision) {
                  <ion-select cancelText="Close" interface="alert" label="{{billing_address_subdivision_label}}" labelPlacement="stacked" fill="outline" [(ngModel)]="params['billing_address_subdivision']">
                    @for (subdivision of billing_address_subdivisions; track subdivision) {
                      <ion-select-option value="{{subdivision.title}}">{{subdivision.title}}</ion-select-option>
                    }
                  </ion-select>
                }
                @if (billing_address_subdivision_label_changed && !billing_address_requires_subdivision) {
                  <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="params['billing_address_subdivision']">
                    <div slot="label">{{billing_address_subdivision_label}}<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                }
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                @if (billing_address_requires_postal_code) {
                  <ion-input type="text" inputmode="text" maxlength="10" label="{{billing_address_postal_code_label}}" labelPlacement="stacked" fill="outline" [(ngModel)]="params['billing_address_postal_code']"></ion-input>
                }
                @if (!billing_address_requires_postal_code) {
                  <ion-input type="text" inputmode="text" maxlength="10" labelPlacement="stacked" fill="outline" [(ngModel)]="params['billing_address_postal_code']">
                    <div slot="label">{{billing_address_postal_code_label}}<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                }
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>